import { render } from "./contractDetail.vue?vue&type=template&id=568a18f0&ts=true"
import script from "./contractDetail.vue?vue&type=script&lang=ts"
export * from "./contractDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__